import {FC} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {SubmitHandler} from 'react-hook-form'
import {EMAIL_TYPES} from 'consts/emailType'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {useNotify} from 'hooks/useNotify'
import {useMutation, useQuery} from 'hooks/graphql'
import {Presenter} from './Presenter'
import {
  CUSTOM_EMAIL,
  CustomEmailQueryResult,
  CustomEmailQueryVariables,
  UPDATE_CUSTOM_EMAIL,
  UpdateCustomEmailQueryVariables,
} from './query'
import {Schema} from './schema'

// @ts-ignore
import NotFound from 'NotFound'

interface EditWithParamsProps {
  emailType: keyof typeof EMAIL_TYPES
}

const EditWithParams: FC<EditWithParamsProps> = ({emailType}) => {
  const history = useHistory()
  const notify = useNotify()
  const {data, loading} = useQuery<CustomEmailQueryResult, CustomEmailQueryVariables>(CUSTOM_EMAIL, {
    variables: {emailType},
    fetchPolicy: 'network-only',
  })
  const defaultEmail = data?.defaultEmail
  const customEmail = data?.client?.customEmail

  const [updateCustomEmail] = useMutation<unknown, UpdateCustomEmailQueryVariables>(UPDATE_CUSTOM_EMAIL)

  if (!loading && !defaultEmail) {
    return <NotFound />
  }

  const handleSubmit: SubmitHandler<Schema> = async (data) => {
    await updateCustomEmail({
      variables: {
        input: {
          emailType,
          subject: data.subject,
          body: data.body,
        },
      },
    })
    history.push(WITH_AUTH_ADMIN_PATHS.SETTINGS.CUSTOM_MAILS.INDEX)
    notify(customEmail ? '更新しました' : '作成しました', 'success')
  }

  return (
    <Presenter
      mailType={emailType}
      loading={loading}
      defaultEmail={defaultEmail}
      customEmail={customEmail}
      onSubmit={handleSubmit}
    />
  )
}

const isValidMailType = (emailType: string): emailType is keyof typeof EMAIL_TYPES => emailType in EMAIL_TYPES

interface RouteParams {
  emailType: string
}

export const Edit: FC = () => {
  const {emailType} = useParams<RouteParams>()

  if (!isValidMailType(emailType)) {
    return <NotFound />
  }

  return <EditWithParams emailType={emailType} />
}
